import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ListView from './ListView';
import ConfigListView from './ConfigListView';
import MasterConfigView from './MasterConfigView';
import AddChildView from './AddChildView';
import PreviewView from './PreviewView';
import './DynamicComp.css';

function DynamicComp() {
  const [view, setView] = useState('list');
  const [editingChild, setEditingChild] = useState(null);
  const [draftFields, setDraftFields] = useState(null);
  const [hasOrderChanged, setHasOrderChanged] = useState(false);
  // Config open in the field editor (set from the config list's Edit).
  const [editingConfigId, setEditingConfigId] = useState(null);
  // List filter: 'all' or a config id.
  const [typeFilter, setTypeFilter] = useState('all');

  const configList = useSelector((state) => state.masterConfig.list);

  const editingConfig =
    configList.find((c) => c._id === editingConfigId) || null;

  // A filtered config that was deleted falls back to showing all.
  const activeTypeFilter = configList.some((c) => c._id === typeFilter)
    ? typeFilter
    : 'all';

  if (view === 'configList') {
    return (
      <ConfigListView
        onBack={() => setView('list')}
        onEditConfig={(id) => {
          // A draft belongs to one config; start clean.
          setEditingConfigId(id);
          setDraftFields(null);
          setHasOrderChanged(false);
          setView('masterConfig');
        }}
      />
    );
  }

  if (view === 'masterConfig') {
    return (
      <MasterConfigView
        masterConfig={editingConfig}
        onBack={() => {
          setDraftFields(null);
          setHasOrderChanged(false);
          setView('configList');
        }}
        onPreview={() => setView('preview')}
        draftFields={draftFields}
        onDraftFieldsChange={setDraftFields}
        hasOrderChanged={hasOrderChanged}
        onHasOrderChangedChange={setHasOrderChanged}
      />
    );
  }

  if (view === 'addChild') {
    return (
      <AddChildView
        defaultConfigId={activeTypeFilter === 'all' ? null : activeTypeFilter}
        onBack={() => setView('list')}
        onMasterConfig={() => setView('configList')}
      />
    );
  }

  if (view === 'editChild') {
    return (
      <AddChildView
        onBack={() => {
          setView('list');
          setEditingChild(null);
        }}
        editData={editingChild}
        onMasterConfig={() => setView('configList')}
      />
    );
  }

  if (view === 'preview') {
    return (
      <PreviewView
        masterConfig={editingConfig}
        onBack={() => setView('masterConfig')}
        previewFields={draftFields}
      />
    );
  }

  return (
    <ListView
      typeFilter={activeTypeFilter}
      onTypeFilterChange={setTypeFilter}
      onMasterConfig={() => setView('configList')}
      onAddChild={() => setView('addChild')}
      onEditChild={(child) => {
        setEditingChild(child);
        setView('editChild');
      }}
    />
  );
}

export default DynamicComp;
